<template>
  <div class="page">
    <!--头部-->
    <div class="title"><i class="iconfont icon-lirunbiao-normal"></i>运费维护浏览</div>

    <div class="page-content">
      <el-form style="font: bold" :inline="true" label-width="120px" size="small" :model="formInline">
        <!-- <el-form-item label="国家编号：">
              <el-input
                v-model="formInline.countryCode"
                clearable
                placeholder="国家编号"
              ></el-input>
            </el-form-item> -->
        <el-form-item label="站点筛选：">
          <el-select v-model="formInline.countryCode" style="width: 120px" clearable placeholder="请选择">
            <el-option v-for="types in dataSites" :key="types.codeValue" :value="types.codeValue" v-text="types.codeName" :label="types.codeName" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryParams" style="backgroundcolor: #2a3861; bordercolor: transparent">查询 </el-button>
        </el-form-item>
      </el-form>
      <!-- 表格区域  :loading="loading"-->
      <el-table
        height="calc(100% - 120px)"
        :data="tableData"
        border
        :header-cell-style="{
          'text-align': 'center',
          background: '#F5F6FA',
          color: '#646E92',
        }"
        style="
            width: 96%;
            margin-top: 10px;
            margin-left: 25px;
            color: #666e92;
            font-size: 14px;
          "
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column prop="countryCode" label="站点" fixed show-overflow-tooltip> </el-table-column>
        <el-table-column prop="description" label="海运名称" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="kgPrice" label="价格（元/kg）" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="cbmPrice" label="价格（元/CBM）" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip> </el-table-column>
        <el-table-column align="center" width="100">
          <template slot="header" slot-scope="scope">
            <span>操作</span>
          </template>
          <template slot-scope="scope">
            <el-link :underline="false" style="color: #7698fc" @click="editSkuinfo(scope.row)"><i class="iconfont icon-xiugai" title="编辑"></i></el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 新增sku弹框 -->
      <el-dialog :title="modelTitle" width="600px" :visible.sync="addRoleDialog" :close-on-click-modal="false" :show-close="false" left>
        <el-form label-width="160px" :model="addrole" ref="addrole" :rules="rules1">
          <el-form-item label="站点：" prop="countryCode">
            <el-input v-model="addrole.countryCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="海运名称：" prop="description">
            <el-input v-model="addrole.description" disabled></el-input>
          </el-form-item>
          <el-form-item label="价格（元/kg）：" prop="kgPrice">
            <el-input v-model="addrole.kgPrice" type="number"></el-input>
          </el-form-item>
          <el-form-item label="价格（元/CBM）：" prop="cbmPrice">
            <el-input v-model="addrole.cbmPrice" type="number"></el-input>
          </el-form-item>
          <!-- <el-form-item label="备注：" prop="remark">
            <el-input v-model="addrole.remark"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button @click="cancelSku()">取 消</el-button>
            <el-button @click="addRole('addrole')" style="background-color: #4c74e0; color: white">提 交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ElRow from "element-ui/packages/row/src/row";
import ElMain from "element-ui/packages/main/src/main";
import ElFooter from "element-ui/packages/footer/src/main";
import moment from "moment";
import SparkMD5 from "spark-md5";
export default {
  components: {
    ElFooter,
    ElMain,
    ElRow,
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    var user = window.sessionStorage["user"];
    return {
      /*创建角色*/
      addRoleDialog: false,
      addrole: {
        id: undefined,
        cbmPrice: "",
        countryCode: "",
        description: "",
        kgPrice: "",
      },
      modelTitle: "",

      rules1: {
        countryCode: [{ required: true, message: "国家编号是必填的", trigger: "blur" }],
        description: [{ required: true, message: "海运名称是必填的", trigger: "blur" }],
      },
      data: [{}] /*绑定新增角色树的数据*/,
      dataBrands: [],
      dataSites: [],
      formInline: {
        countryCode: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      btn: false,
      fileList: [],
      file: {},
      row: "",
      col: "",
      tmpRow: {},
      Fnupload: {
        id: "",
        businessType: "",
      },
      uploadDialog: false,
      dialogVisible: false,
      fileFnList: [],
      businessType: 0,
      formFilename: "上传文件",
      downDialog: false,
      downDetailfnskuPdfPath: "",
      skuId: "",
      flagClick: false,
      // 双击修改
      attribute: false,
      cost: false,
      failReason: false,
      fnsku: false,
      numberPackages: false,
      packagesHigh: false,
      packagesLong: false,
      packagesWeight: false,
      packagesWide: false,
      shopName: false,
      site: false,
      sku: false,
      type: false,
    };
  },
  created() {
    this.query(); /*绑定树*/
    this.getAllDicts();
  },
  methods: {
    getAllDicts() {
      /*获取所有字典*/
      this.axios.get("/api/dict/map").then((r) => {
        let data = r.data.data;
        for (var key in data) {
          if (key.indexOf("1120") == 0) {
            // 品牌
            this.dataBrands = data[key];
          }
          if (key.indexOf("1130") == 0) {
            // 站点
            // 站点
            let siteData = data[key];
            siteData.map((item) => {
              item.codeName = item.codeValue + "（" + item.codeName + "）";
            });
            this.dataSites = siteData;
          }
        }
      });
    },

    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    handleSizeChange(val) {
      /*改变显示条数*/
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange() {
      this.query();
    },
    putdata(resp) {
      console.log(resp.data, "resp.data");
      this.$data.tableData = resp.data.data && resp.data.data ? resp.data.data : [];
    },
    queryParams() {
      this.$data.currentPage = 1;
      this.query();
    },
    query() {
      //条件筛选
      let o = {
        ...this.formInline,
      };
      if (this.formInline.countryCode == "" || this.formInline.countryCode == null) {
        delete o.countryCode;
      }
      this.axios
        .get("/api/freight-price/listFreightPrice", {
          params: { ...o },
        })
        .then(this.putdata, (err) => {
          console.log("err", err);
        });
    },
    addSkuinfo() {
      this.addRoleDialog = true;
      this.modelTitle = "新增SKU信息";
      this.flagClick = true;
    },
    cancelSku() {
      this.addrole = {
        id: undefined,
        cbmPrice: "",
        countryCode: "",
        description: "",
        kgPrice: "",
      };
      this.addRoleDialog = false;
    },
    editSkuinfo(row) {
      /*绑定修改信息*/
      this.addRoleDialog = true;
      this.modelTitle = "修改运费信息";
      this.addrole = JSON.parse(JSON.stringify(row));
      this.addrole.description = row.description;
    },
    addRole(addrole) {
      /*新增修改*/
      this.$refs[addrole].validate((valid) => {
        if (valid) {
          let info = {
            cbmPrice: parseFloat(this.addrole.cbmPrice),
            description: this.addrole.description,
            id: this.addrole.id,
            countryCode: this.addrole.countryCode,
            kgPrice: parseFloat(this.addrole.kgPrice),
          };
          if (
            (info.cbmPrice == "" && info.kgPrice == "") ||
            (info.cbmPrice == null && info.kgPrice == null) ||
            (Number.isNaN(info.cbmPrice) && Number.isNaN(info.kgPrice))
          ) {
            this.$message.info("价格不能为空");
            return;
          }
          if (info.cbmPrice != null && info.cbmPrice != "" && !Number.isNaN(info.cbmPrice)) {
            if (info.kgPrice != null && info.kgPrice != "" && !Number.isNaN(info.kgPrice)) {
              this.$message.info("价格只能填写一个");
              console.log(Number.isNaN(info.kgPrice), "info.kgPrice");
              return;
            } else {
              delete info.kgPrice;
            }
          }
          if (info.kgPrice != null && info.kgPrice != "" && !Number.isNaN(info.kgPrice)) {
            if (info.cbmPrice != null && info.cbmPrice != "" && !Number.isNaN(info.cbmPrice)) {
              this.$message.info("价格只能填写一个");
              console.log(Number.isNaN(info.cbmPrice), "info.cbmPrice");
              return;
            } else {
              delete info.cbmPrice;
            }
          }

          if (info.id) {
            this.axios.put("/api/freight-price/modifyFreightPrice", info).then(
              (resp) => {
                if (resp.data.code == 200) {
                  this.$message("修改成功");
                  this.query(); /*查询渲染界面*/
                } else {
                  this.$message.info(resp.data.msg);
                }
              },
              (err) => {
                console.log("err", err);
              }
            );
          } else {
            this.axios.post("/api/sku-info/add", role).then(
              (resp) => {
                if (resp.data.code == 200) {
                  this.$message("添加成功");
                  this.query(); /*查询渲染界面*/
                } else {
                  this.$message.info(resp.data.msg);
                }
              },
              (err) => {
                console.log("err", err);
              }
            );
          }
          this.cancelSku(); /*关闭弹窗*/
        } else {
          console.log("验证没通过");
          return false;
        }
      });
    },

    deleteRoleGetId(row) {
      /*删除角色*/
      this.$msgbox
        .confirm("此操作将删除SKU信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.axios.delete("/api/sku-info/removeById?id=" + row.id).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.$message("删除成功");
                this.query();
              } else {
                this.$message(resp.data.msg);
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        })
        .catch(() => {
          this.$message.error("已取消");
        });
    },
  },
  mounted: function() {
    this.active = this.$route.name;
    this.query();
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: calc(100vh - 70px);
  overflow: hidden;
  .title {
    height: 50px !important;
    color: white;
    font-size: 16px;
    background: #c1a1ca;
    line-height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  &-content {
    background-color: white;
    height: calc(100vh - 50px);
    overflow: hidden;
    .el-form{
      width: 100%;
      margin-top: 15px;
    }
  }
  /*分页插件*/
  .el-pagination {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    z-index: 55555;
  }
}
.center-dialog {
  top: 20%;
}
.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #c1a1ca;
}

/*滚动条样式*/
/deep/ .scrollbar {
  white-space: nowrap;
  .el-scrollbar {
    display: flex;
    justify-content: space-around;
    padding: 0 10px;
  }
  /deep/ .el-scrollbar__wrap {
    overflow: scroll;
    width: 110%;
    height: 100%;
  }
}

.ant-card {
  width: 1230px;
  height: 600px;
  background: #ffffff;
  border-radius: 6px;

  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  transition: all 0.3s;
}
.showAll_dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ::v-deep .el-dialog {
    margin: 0 auto !important;
    height: 40%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
      // 下边设置字体，我的需求是黑底白字
      color: #ffffff;
      line-height: 30px;
      padding: 0 15px;
    }
  }
}
</style>
